import { GameConstants } from "../../GameConstants";

import { GameVars } from "../../GameVars";

 export class MovementsCapsule extends Phaser.Group {
    
    private puzzleLabel: Phaser.Text;
    private movementsLabel: Phaser.Text;

    private movementsLeft: Phaser.Image[];

    constructor(game: Phaser.Game) {

        super(game, null, "hud");

        this.x = GameConstants.GAME_WIDTH / 2;
        this.scale.y = GameVars.scaleY;

        this.movementsLeft = [];

        for (let i = 0; i < GameVars.levelMoves; i++) {
            let movementImage = new Phaser.Image(this.game, 70 * i - ((GameVars.levelMoves - 1) * 35), 105, "texture_atlas_1", "tab_" + (i + 1) + ".png");
            movementImage.anchor.set(.5, 0);
            this.add(movementImage);
            this.movementsLeft.push(movementImage);
        }

        const movesCapsule = new Phaser.Image(this.game, 0, 0, "texture_atlas_1", "menu_tab.png");
        movesCapsule.anchor.set(.5, 0);
        movesCapsule.scale.set(1.4);
        this.add(movesCapsule);

        this.puzzleLabel = new Phaser.Text(this.game, 10, 55, "puzzle " + GameVars.currentLevelName, { font: "54px Roboto Slab Regular", fill: "#1b2d3d"});
        this.puzzleLabel.anchor.set(1, .5);
        this.add(this.puzzleLabel);

        this.movementsLabel = new Phaser.Text(this.game, 20, 55, "- " + GameVars.levelMoves + " MOVES", { font: "54px Roboto Slab Bold", fill: "#1b2d3d"});
        this.movementsLabel.anchor.set(0, .5);
        this.add(this.movementsLabel);
        
    }

    public updateMoves(): void {

        this.game.add.tween(this.movementsLeft[GameVars.levelMoves])
            .to({y: this.movementsLeft[GameVars.levelMoves].y - 100}, 500, Phaser.Easing.Linear.None, true);
    }
}
